import { render } from "./authenticationManagement.vue?vue&type=template&id=fae679be"
import script from "./authenticationManagement.vue?vue&type=script&lang=js"
export * from "./authenticationManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__